<div class="grid">
    @for (page of pages; track page) {
        <app-dashboard-card class="col-6 lg:col-3" [icon]="page.icon" [title]="page.title" [menuButton]="false" [routerLink]="page.routerLink"></app-dashboard-card>
    }
</div>